import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { XUser, XUserInteraction } from '@core/utils';
import {
  INIT_SET_RAPORTY,
  SET_RAPORT_DATA,
  REMOVE_RAPORT,
  CLEAR_RAPORT_DATA,
  REFRESH_RAPORT_DATA,
  CLEAR_RAPORT_REFRESH
} from '@modules/raccoon/src/redux/types';
import {
  getRaportStartowy,
  getRaportyStartowe
} from '@modules/raccoon/src/api/raportyStartowe';
import { dataSetup, getProperDate } from './utils/data';

const useRaporty = () => {
  const raportyTimeouts = useRef([]);

  const dispatch = useDispatch();

  const { raportToRefresh, userRole } = useSelector((state) => ({
    raportToRefresh: state.raportToRefresh,
    userRole: state.user.data.role
  }));

  const onTimeout = (raportData) => {
    dispatch({ type: REFRESH_RAPORT_DATA, payload: raportData });
  };

  const setTimeouts = (raportData) => {
    const { id } = raportData;

    const raport = raportyTimeouts.current.find((e) => e.id === id);

    if (raport) {
      clearTimeout(raport.timeout);
      raport.timeout = setTimeout(() => onTimeout(raportData), 300000);
    } else {
      raportyTimeouts.current.push({
        id,
        timeout: setTimeout(() => onTimeout(raportData), 300000)
      });
    }
  };

  const fetchRaport = (raportData) => {
    const { id, typ } = raportData;

    dispatch({ type: CLEAR_RAPORT_DATA, payload: raportData.id });

    getRaportStartowy(id)
      .then(({ data }) => {
        const { chartData, groups } = dataSetup(typ, data);

        dispatch({
          type: SET_RAPORT_DATA,
          payload: {
            id,
            data: {
              raportData: chartData || data,
              groups,
              date: getProperDate()
            }
          }
        });

        setTimeouts(raportData);
      })
      .catch(() => {
        dispatch({ type: REMOVE_RAPORT, payload: id });
      });
  };

  useEffect(() => {
    if (raportToRefresh.id) {
      fetchRaport(raportToRefresh);
      dispatch({ type: CLEAR_RAPORT_REFRESH });
    }
  }, [raportToRefresh.id]);

  useEffect(() => {
    getRaportyStartowe()
      .then(({ data }) => {
        const allowedData = [];

        data.forEach((e) => {
          const userAllowed =
            e.role === null
              ? true
              : XUser.isUserCombinedRoleAllowed(e.role, userRole);

          if (userAllowed) {
            allowedData.push(e);
          }
        });

        dispatch({
          type: INIT_SET_RAPORTY,
          payload: allowedData.length === 0 ? null : allowedData
        });

        allowedData.forEach((e) => fetchRaport(e));
      })
      .catch(XUserInteraction.notifyError);

    return () => {
      raportyTimeouts.current.forEach((raport) => {
        clearTimeout(raport.timeout);
      });
    };
  }, []);
};

export default useRaporty;
